// extracted by mini-css-extract-plugin
module.exports = {"supportersAnchor":"TotalRaised_supportersAnchor__0HTtg","raisedBySection":"TotalRaised_raisedBySection__U7Ddh"};